import React from 'react';
import * as rentReportingConstants from '../../../../constants/rentReportingConstants';

import { Box } from '@zillow/constellation-10';

interface ArrayCreditOverviewMiniProps {
  userToken: string | null;
}

const ArrayCreditOverviewMini: React.FC<ArrayCreditOverviewMiniProps> = ({ userToken }) => {
  return (
    <Box>
      <div
        dangerouslySetInnerHTML={{
          __html: `
                <array-credit-overview-mini
                    appKey="${rentReportingConstants.CREDIT_TRACKING_CONFIG.appKey}"
                    ${!rentReportingConstants.isProd ? 'sandbox="true"' : ''}
                    userToken="${userToken}"
                    hideScoreFactors="true"
                    hideCtaButton="true"
                    hideBureauLogo="true">
                </array-credit-overview-mini>`,
        }}
      />
    </Box>
  );
};

export default ArrayCreditOverviewMini;
